import { render } from "./Thongkebenhnhan.vue?vue&type=template&id=85dee1f8&scoped=true&ts=true"
import script from "./Thongkebenhnhan.vue?vue&type=script&lang=ts"
export * from "./Thongkebenhnhan.vue?vue&type=script&lang=ts"

import "./Thongkebenhnhan.vue?vue&type=style&index=0&id=85dee1f8&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/Dashboard_YHCT/Dashboard_FE_YHCT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85dee1f8"]])

export default __exports__